import { render, staticRenderFns } from "./CDC-Total.vue?vue&type=template&id=264a1adb&scoped=true"
import script from "./CDC-Total.vue?vue&type=script&lang=js"
export * from "./CDC-Total.vue?vue&type=script&lang=js"
import style0 from "./CDC-Total.vue?vue&type=style&index=0&id=264a1adb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a1adb",
  null
  
)

export default component.exports